import { logger } from '@sheerid/jslib';
import { SubmissionBody } from '../types/types';
import { successNotifierUrl } from '../../programOptions';

const processResponse = async (response: Response): Promise<Object> => {
    let responseData: Promise<Object>;
    try {
        responseData = await response.json();
    } catch {
        // Handle 204 response
        responseData = Promise.resolve({});
    }
    logger.info('Response received', responseData);
    return responseData;
};

export const postSucessNotification = async (submissionBody: SubmissionBody) => {
    const submissionUrl = successNotifierUrl;
    const response = await fetch(submissionUrl, {
        method: 'POST',
        body: JSON.stringify(submissionBody),
    });
    logger.info('Received response from success submission', processResponse(response));
};
